// @ts-nocheck
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Radio, { RadioProps } from "@insite/mobius/Radio";
import MobiusRadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { ChangeEvent, FC, useState } from "react";
import { useTheme } from "styled-components";

const errorText = "An option needs to be selected.";

const Row: FC<RadioProps & { label: string; sizeVariant: RadioGroupProps["sizeVariant"] }> = ({
    label,
    sizeVariant,
    ...props
}) => (
    <>
        <GridItem width={4}>
            <MobiusRadioGroup sizeVariant={sizeVariant} value="checked">
                <Radio {...props}>{label}</Radio>
            </MobiusRadioGroup>
        </GridItem>
        <GridItem width={4}>
            <MobiusRadioGroup sizeVariant={sizeVariant} value="checked">
                <Radio disabled {...props}>
                    {label} (Disabled)
                </Radio>
            </MobiusRadioGroup>
        </GridItem>
        <GridItem width={4} />
    </>
);

const RadioGroup: FC<RadioGroupProps> = props => {
    const [value, setValue] = useState("none");

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.currentTarget.value);
    };

    return (
        <MobiusRadioGroup {...props} value={value} onChangeHandler={onChange}>
            <Radio value="1">Lorem Ipsum</Radio>
            <Radio value="2">Lorem Ipsum</Radio>
            <Radio value="3">Lorem Ipsum</Radio>
        </MobiusRadioGroup>
    );
};

const GroupRow: FC<RadioGroupProps> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <RadioGroup label={label} {...props} />
        </GridItem>
        <GridItem width={4}>
            <RadioGroup label={`${label} (Required)`} required {...props} />
        </GridItem>
        <GridItem width={4}>
            <RadioGroup label={`${label} (Error)`} error={errorText} {...props} />
        </GridItem>
    </>
);

const Variant: FC<RadioGroupProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);

    return (
        <StyleguideSection title={upperFirst(sizeVariant)} variant="h3">
            <GridContainer {...gridContainerProps}>
                <Row label="Default" sizeVariant={sizeVariant} value="unchecked" />
                <Row label="Checked" sizeVariant={sizeVariant} value="checked" />
                <GroupRow label="Group" sizeVariant={sizeVariant} />
                <GridItem width={4}>
                    <MobiusRadioGroup sizeVariant={sizeVariant} value="checked">
                        <Radio value="unchecked">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent mollis commodo tincidunt.
                            Fusce rhoncus condimentum ex, vel consectetur justo tempus et.
                        </Radio>
                    </MobiusRadioGroup>
                </GridItem>
                <GridItem width={8}>
                    <RadioGroup sizeVariant={sizeVariant} label="Horizontal Group" horizontal />
                </GridItem>
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideRadios: FC = () => (
    <StyleguideSection title="Radios">
        <Variant sizeVariant="default" />
        <Variant sizeVariant="small" />
    </StyleguideSection>
);

export default StyleguideRadios;
